import React from "react";
import Select from "react-select";
import { reactSelectStyles } from "./ReactSelectStyles";

const FormSelect = ({
  field,             // field object from JSON (name, label, required, fieldSize)
  value,             // current value
  handleChange,      // onChange handler
  options = [],      // array of options [{ value, label }]
  placeholder = "Select an option",
  error = null,
  disabled = false,   // validation error
  formatOptionLabel = null, // Custom option label renderer
  customStyles = {},  // Additional style overrides
  noLabel = false,    // Hide label and wrapper div
}) => {
  // Convert options to React Select format
  const reactSelectOptions = [
    ...(field.placeholder ? [{ value: "", label: field.placeholder }] : []),
    ...options.map(opt => ({ ...opt, value: opt.value, label: opt.label }))
  ];


  // Find the selected option from React Select options
  const selectedOption = reactSelectOptions.find(option => option.value == value) || null;
  // Handle React Select onChange
  const handleReactSelectChange = (selectedOption) => {
    // Call the original handleChange with the value (maintaining existing behavior)
    if (handleChange) {
      // Create a synthetic event object that matches what the original handler expects
      const syntheticEvent = {
        target: {
          name: field.name,
          value: selectedOption ? selectedOption.value : ""
        }
      };
      handleChange(syntheticEvent);
    }
  };

  // Merge base styles with error-specific overrides
  const getStylesWithError = () => {
    return {
      ...reactSelectStyles,
      ...customStyles,
      control: (provided, state) => {
        const baseControl = reactSelectStyles.control(provided, state);
        const errorStyles = error ? {
          borderColor: '#dc3545',
          '&:hover': { borderColor: '#dc3545' },
        } : {};

        return {
          ...baseControl,
          ...errorStyles,
          ...(customStyles.control ? customStyles.control(provided, state) : {}),
        };
      },
    };
  };

  const selectElement = (
    <Select
      name={field.name}
      value={selectedOption}
      onChange={handleReactSelectChange}
      options={reactSelectOptions}
      placeholder={field.placeholder || placeholder}
      isClearable={false}
      isSearchable={true}
      className={`react-select-container ${error ? "is-invalid" : ""}`}
      classNamePrefix="react-select"
      isDisabled={disabled || field.disabled}
      formatOptionLabel={formatOptionLabel}
      menuPosition="fixed"
      menuPortalTarget={typeof window !== "undefined" ? document.body : null}
      styles={{
        ...getStylesWithError(),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
      }}
    />
  );

  if (noLabel) {
    return selectElement;
  }

  return (
    <div className={field.fieldSize || "col-12"}>
      {!field.labelHide && (
        field.label !== null && field.label !== undefined ? (
          <label className={`form-label text-capitalize text-muted ${field.labClass && field.labClass}`}>
            {field.label}{" "}
            {field.required && <span className="text-danger small">*</span>}
          </label>
        ) : (
          <label className={`mt-sm-4 ${field.labClass && field.labClass}`}></label>
        ))}

      {selectElement}

      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

export default FormSelect;
